import ProductDescription from './ProductDescription'

const PeanutButterProduct = {
  ...ProductDescription,
  category: '06',
  subCategory: '001',
  IsBroadband: true,
  PBType: '',
  PBTexture: '',
  PBContainerSize: '',
  otherTexture: '',
}

export default PeanutButterProduct